import { render } from "./SocialInput.vue?vue&type=template&id=22fc020d&scoped=true"
import script from "./SocialInput.vue?vue&type=script&lang=js"
export * from "./SocialInput.vue?vue&type=script&lang=js"

import "./SocialInput.vue?vue&type=style&index=0&id=22fc020d&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22fc020d"]])

export default __exports__